import React from "react";
import LinkComp from "../LinkComp/LinkComp";

export default ({id, svg, index, onMouseEnter, onMouseLeave}) => (
    <LinkComp to={`${arc.path.base}training/${id}`}
              className='puzzle-container'>
        <img src={svg}
             className='puzzle-img'
             onMouseEnter={() => onMouseEnter(index)}
             onMouseLeave={() => onMouseLeave()}/>
    </LinkComp>
)